





























































































































































































































































































import Vue from 'vue'
import EditItemsForm from '@/components/EditInventoryItemsForm.vue'
import InventoryItemForm from '@/components/InventoryItemForm.vue'
import { mapState } from 'vuex'
import { ApiResponse, Project, InventoryItem } from '@/interfaces'
import QuickNav from '@/components/QuickNav.vue'
import { MessageBoxInputData } from 'element-ui/types/message-box'
import ItemFilters from '@/components/ItemFilters.vue'
import ItemRow from '@/views/inventoryItems/ItemRow.vue'

interface DropdownAction {
  action: string
  renumberBy?: string
}

interface Parameter {
  tab?: string
  place?: string
  location?: string
  search?: string
  page?: string
  orderby?: string
  order?: string
  rubriques?: string[]
  stockStatuses?: string[]
  entryDate?: string[]
  itemNumber?: string
  stockId?: string
  sale?: number
  requisition?: number
  dateOut?: string
  sort?: string
}

// interface FileUpdatedInfos {
//   item: ItemFile
//   itemFiles: ItemFile[]
// }

// interface FileAddedInfos {
//   itemId: number
//   file: ItemFile
// }

// interface TransferParams {
//   requisition: null
//   items: number[]
//   useStickerAsStockId?: boolean
//   checkIfStockIdExist?: boolean
// }

export default Vue.extend({
  components: { InventoryItemForm, EditItemsForm, QuickNav, ItemFilters, ItemRow },
  props: {
    project: {
      type: Object as () => Project,
      required: false,
      default: null,
    },
    activeTab: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      addons: 0,
      busy: false,
      items: [] as InventoryItem[],
      filteredItems: [] as InventoryItem[],
      query: null as Parameter | null,
      itemsId: [] as number[],
      itemsChecked: [] as boolean[],
      checkAll: false,
      indeterminate: false,
      showAddInventoryItemModal: false,
      showTransferModal: false,
      showInvTransferModal: false,
      invProjects: [] as Project[],
      reqProjects: [] as Project[],
      itemsToEdit: [] as number[],
      showEditModal: false,
      transferTo: null,
      itemEdit: null as InventoryItem | null,
      //saveTrigger: false,
      resetChange: false,
      //isInventoryTransfer: true,
      useStickerAsStockId: false,
      useStickerAsItemNumber: false,
      checkIfStockIdExist: true,
      showCreateRequisitionModal: false,
      lastCheckedId: null as number | null,
      checkAction: '',
      checkedItemsNumber: 0,
      refreshAtClose: false,
      showAIModal: false,
      aiLevel: 1,
      aiPendingItem: null as InventoryItem | null,
    }
  },
  computed: {
    ...mapState(['user']),
    nextSticker(): number | null {
      const stickers = this.items
        .map((item: InventoryItem) => Number(item.sticker))
        .filter((sticker: number) => Number.isFinite(sticker) && sticker > 0)

      return stickers.length > 0 ? Math.max(...stickers) + 1 : null
    },
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 'items' && this.items.length === 0) {
        this.fetchInventoryItems(this.project.inventory?.id ?? null)
      }
    },
    // Filet de sécurité : sur un F5/deep-link vers l'onglet Lots, activeTab peut devenir 'items' avant que project.inventory.id soit chargé
    project(newVal) {
      if (this.activeTab === 'items' && this.items.length === 0) {
        this.fetchInventoryItems(newVal?.inventory?.id ?? null)
      }
    },
    user(newVal) {
      this.addons = newVal.client?.addons ?? 0
    },
    items: {
      deep: true,
      immediate: true,
      handler() {
        // La case « tout » ne concerne que les lots visibles (filtrés)
        const visibleChecked = this.filteredItems.map((item: InventoryItem) => item.isChecked === true)
        const allChecked = visibleChecked.length > 0 && visibleChecked.every((checked) => checked)
        const noneChecked = visibleChecked.every((checked) => !checked)

        if (!allChecked && !noneChecked) {
          this.indeterminate = true
        } else {
          this.indeterminate = false
          this.checkAll = allChecked
        }
      },
    },
  },
  mounted() {
    if (this.activeTab === 'items' && this.items.length === 0) {
      this.fetchInventoryItems(this.project.inventory?.id ?? null)
    }
    if (this.user) {
      this.addons = this.user.client?.addons ?? 0
    }
  },
  methods: {
    addonTest(code: number) {
      if (!isNaN(this.addons)) {
        return BigInt(code) & BigInt(this.addons)
      } else {
        return false
      }
    },
    fetchInventoryItems(id: number | null) {
      if (id) {
        const loading = this.$loading({
          target: '.items-container',
          text: 'Chargement des données...',
        })
        this.$api
          .get(`/inventory/${id}/items`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            // Resetting arrays
            this.items = []
            this.itemsId = []
            this.itemsChecked = []

            apiResponse.data.forEach((item: InventoryItem) => {
              if (item.id) {
                const updatedItem = {
                  ...item,
                  isChecked: false,
                } as InventoryItem
                this.items.push(updatedItem)
                this.itemsId.push(item.id)
                this.itemsChecked.push(false)
              }
            })

            this.$emit('updateItemsCount', this.items.length)
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
          .finally(() => {
            loading.close()
            this.filterItemList()
          })
      }
    },
    toggleCheckAll(status: boolean) {
      this.indeterminate = false
      // Cocher : uniquement les lots visibles. Décocher : tous les lots.
      const visibleIds = new Set(this.filteredItems.map((item: InventoryItem) => item.id))
      this.items.forEach((item: InventoryItem, i: number) => {
        if (!status || visibleIds.has(item.id)) {
          this.items[i].isChecked = status
          this.itemsChecked[i] = status
        }
      })

      if (!status) {
        this.itemsToEdit = []
        this.checkAll = false
        this.lastCheckedId = null
        this.checkAction = ''
      }
      this.checkedItemsNumber = this.itemsChecked.filter((checkedStatus: boolean) => checkedStatus)?.length
    },
    // Position réelle du lot dans `items` (l'index d'affichage de `filteredItems` peut différer : tri, filtres)
    realIndex(item: InventoryItem): number {
      return this.items.findIndex((i: InventoryItem) => i.id === item.id)
    },
    toggleChecked(item: InventoryItem, index: number, event: PointerEvent | null) {
      const realIdx = this.realIndex(item)
      if (realIdx === -1) {
        return
      }

      this.itemsChecked[realIdx] = !this.itemsChecked[realIdx]
      this.checkAction = this.itemsChecked[realIdx] ? 'select' : 'deselect'

      if (event?.shiftKey && this.lastCheckedId !== null && this.checkAction === 'select') {
        // `index` est la position affichée : la plage se calcule sur filteredItems
        const lastIndex = this.filteredItems.findIndex((i: InventoryItem) => i.id === this.lastCheckedId)
        if (lastIndex !== -1) {
          const start = Math.min(lastIndex, index)
          const end = Math.max(lastIndex, index)
          for (let i = start; i <= end; i++) {
            const rangeItem = this.filteredItems[i]
            const rangeIdx = this.realIndex(rangeItem)
            if (rangeIdx !== -1) {
              this.itemsChecked[rangeIdx] = true
              this.items[rangeIdx].isChecked = true
            }
          }
        }
        window?.getSelection()?.removeAllRanges()
      }

      this.lastCheckedId = item.id ?? null
      item.isChecked = this.checkAction === 'select'
      this.checkedItemsNumber = this.itemsChecked.filter((checkedStatus: boolean) => checkedStatus)?.length

      if (this.itemsChecked.every((item) => !item)) {
        // Reset multiple selection data
        this.lastCheckedId = null
        this.checkAction = ''
      }
    },
    editInventoryItem(item: InventoryItem) {
      this.itemEdit = item
      this.showAddInventoryItemModal = true
    },
    // Mise à jour ciblée après édition d'un lot ; si la position a changé, on redemande la liste triée au backend
    // plutôt que de dupliquer sa logique de tri côté client (comme pour l'ajout/la suppression d'un lot)
    handleItemUpdated(updatedItem: InventoryItem) {
      const positionChanged = this.itemEdit?.position !== updatedItem.position

      this.showAddInventoryItemModal = false
      this.refreshAtClose = false

      if (positionChanged) {
        this.fetchInventoryItems(this.project.inventory?.id ?? null)
        return
      }

      const idxInItems = this.items.findIndex((item) => item.id === updatedItem.id)
      if (idxInItems !== -1) {
        // isChecked est un champ client-only absent de la réponse API : on le préserve pour garder la réactivité de la case à cocher
        this.$set(this.items, idxInItems, { ...updatedItem, isChecked: this.items[idxInItems].isChecked })
      }
      this.filterItemList()
    },
    duplicateInventoryItem(item: InventoryItem) {
      if (item) {
        this.$confirm('Êtes-vous sûr(e) de vouloir dupliquer ce lot ?', 'Confirmation', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({
            target: '.items-container',
            text: 'Duplication en cours...',
          })
          this.$api
            .post(`/inventory/${this.project.id}/item/${item.id}/duplicate`)
            .then((response) => {
              const apiResponse = response.data as ApiResponse

              const newItem = apiResponse.data as InventoryItem
              const currentIndex = this.realIndex(item)
              const newIndex = currentIndex === -1 ? this.items.length : currentIndex + 1
              this.items.splice(newIndex, 0, newItem)
              if (newItem.id) {
                this.itemsId.splice(newIndex, 0, newItem.id)
                this.itemsChecked.splice(newIndex, 0, false)
              }
              this.$emit('updateItemsCount', this.items.length)
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: 'Opération réalisée avec succès !',
              })
            })
            .catch(() => {
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message: 'Une erreur est survenue. Merci de reéssayer plus tard.',
              })
            })
            .then(() => {
              loading.close()
            })
        })
      }
    },
    deleteInventoryItem(item: InventoryItem) {
      if (item) {
        this.$confirm(
          'Êtes-vous sûr(e) de vouloir supprimer ce lot ? Attention, cette opération est irréversible.',
          'Confirmation',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'warning',
          }
        ).then(() => {
          this.$api
            .delete(`/inventory/${this.project.id}/item/${item.id}`)
            .then(() => {
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: 'Opération réalisée avec succès !',
              })

              const idx = this.items.findIndex((i) => i.id === item.id)
              if (idx !== -1) {
                this.items.splice(idx, 1)
                this.itemsId.splice(idx, 1)
                this.itemsChecked.splice(idx, 1)
              }
              this.$emit('updateItemsCount', this.items.length)
              this.filterItemList()
            })
            .catch(() => {
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message: 'Une erreur est survenue. Merci de reéssayer plus tard.',
              })
            })
        })
      }
    },
    // Mise à jour ciblée d'une seule ligne après un upload de photo, sans recharger toute la liste ni la sélection en cours
    handleItemFilesUploaded(updatedItem: InventoryItem) {
      const idxInItems = this.items.findIndex((item) => item.id === updatedItem.id)
      if (idxInItems !== -1) {
        // isChecked est un champ client-only absent de la réponse API : on le préserve pour garder la réactivité de la case à cocher
        this.$set(this.items, idxInItems, { ...updatedItem, isChecked: this.items[idxInItems].isChecked })
      }

      const idxInFiltered = this.filteredItems.findIndex((item) => item.id === updatedItem.id)
      if (idxInFiltered !== -1) {
        this.$set(this.filteredItems, idxInFiltered, { ...updatedItem, isChecked: this.filteredItems[idxInFiltered].isChecked })
      }
    },
    deleteInventoryItems() {
      let items = [] as number[]

      for (let index = 0; index < this.itemsChecked.length; index++) {
        if (this.itemsChecked[index] === true) {
          items.push(this.items[index].id ?? 0)
        }
      }

      if (items.length > 0) {
        this.$confirm(
          'Êtes-vous sûr(e) de vouloir supprimer ce(s) lot(s) ? Attention, cette opération est irréversible.',
          'Confirmation',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'warning',
          }
        ).then(() => {
          this.$api
            .delete(`/inventory/${this.project.id}/items`, {
              data: {
                items,
              },
            })
            .then(() => {
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: 'Opération réalisée avec succès !',
              })

              items.forEach((id) => {
                const idx = this.items.findIndex((i) => i.id === id)
                if (idx !== -1) {
                  this.items.splice(idx, 1)
                  this.itemsId.splice(idx, 1)
                  this.itemsChecked.splice(idx, 1)
                }
              })
              this.$emit('updateItemsCount', this.items.length)
              this.filterItemList()
            })
        })
      }
    },
    fusionInventoryItems() {
      let items = [] as number[]

      for (let index = 0; index < this.itemsChecked.length; index++) {
        if (this.itemsChecked[index] === true) {
          items.push(this.items[index].id ?? 0)
        }
      }

      if (items.length > 0) {
        this.$confirm(
          'Êtes-vous sûr(e) de vouloir fusionner le(s) lot(s) ? Attention, cette opération est irréversible.',
          'Confirmation',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'warning',
          }
        ).then(() => {
          this.$api
            .put(`/inventory/${this.project.id}/fusionItems`, {
              items,
            })
            .then(() => {
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: 'Opération réalisée avec succès !',
              })

              this.fetchInventoryItems(this.project.inventory?.id ?? null)
            })
        })
      }
    },
    openInventoryItemModal() {
      this.itemEdit = null
      this.showAddInventoryItemModal = true
    },
    handleItemCommand(command: DropdownAction) {
      // Add new item
      if (command.action == 'add') {
        this.openInventoryItemModal()
      }

      // Renumber items
      if (command.action == 'renumber') {
        this.renumber(command.renumberBy ?? null)
      }

      // Mass edit
      if (command.action == 'massEdit') {
        this.editInventoryItems()
      }

      // Mass delete
      if (command.action == 'massDelete') {
        this.deleteInventoryItems()
      }

      // Mass transfer to other inventory
      if (command.action == 'massInvTransfer') {
        this.showInvTransferModal = true
        //this.isInventoryTransfer = true
      }

      // Mass transfer to requisition
      if (command.action == 'massRequisTransfer') {
        this.showTransferModal = true
        //this.isInventoryTransfer = false
      }

      // Mass fusion
      if (command.action == 'massFusion') {
        this.fusionInventoryItems()
      }

      // Download photos
      if (command.action == 'MassDownloadImages') {
        this.massDownloadImages()
      }

      // massIA
      if (command.action == 'massIA') {
        this.openAIModal(null)
      }
    },
    openAIModal(item: InventoryItem | null) {
      this.aiPendingItem = item
      this.aiLevel = 1
      this.showAIModal = true
    },
    confirmAI() {
      this.showAIModal = false
      if (!this.busy) {
        this.busy = true

        let items = [] as number[]

        if (this.aiPendingItem && this.aiPendingItem.id) {
          items.push(this.aiPendingItem.id)
        } else {
          for (let index = 0; index < this.itemsChecked.length; index++) {
            if (this.itemsChecked[index] === true) {
              items.push(this.items[index].id ?? 0)
            }
          }
        }

        this.$api
          .put(`/ia/inventoryitems`, {
            ids: items,
            level: this.aiLevel,
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            if (apiResponse.success === true) {
              this.fetchInventoryItems(this.project.inventory?.id ?? null)
            }
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    massDownloadImages() {
      if (!this.busy) {
        this.busy = true

        let items = [] as number[]
        for (let index = 0; index < this.itemsChecked.length; index++) {
          if (this.itemsChecked[index] === true) {
            items.push(this.items[index].id ?? 0)
          }
        }

        let success = false
        this.$api
          .post(`/file/mass-download-images/inventory`, {
            ids: items,
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            if (apiResponse.success === true) {
              const documentUrl = `${process.env.VUE_APP_API_URL}/document/${apiResponse.data.filename}/download_once`
              window.open(documentUrl, '_blank')
            }
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    hideInventoryItemModal(refreshList: boolean) {
      // Si creation "a nouveau" on recharge pas la liste en fermant la popup
      if (refreshList || this.refreshAtClose) {
        this.fetchInventoryItems(this.project.inventory?.id ?? null)
        this.refreshAtClose = false
      }
      this.showAddInventoryItemModal = false
    },
    refreshItemList(continueEdit: boolean) {
      // Si creation a nouveau on ne recharge pas la liste, elle sera rechargée en fermant la popup
      if (continueEdit) {
        this.refreshAtClose = true
        this.filterItemList()
      } else {
        this.showAddInventoryItemModal = false
        this.fetchInventoryItems(this.project.inventory?.id ?? null)
        this.refreshAtClose = false
      }
    },
    getProjectTitle(project: Project): string {
      if (project.requisition) {
        return `${project.generatedNumber ?? '-'} - ${project.requisition?.debiteur?.formName ?? '-'}`
      }
      if (project.inventory) {
        return `${project.generatedNumber ?? '-'} - ${project.inventory?.debiteur?.formName ?? '-'}`
      }
      return `${project.generatedNumber ?? '-'}`
    },
    searchInventories(query: string): Project[] {
      if (query.length >= 3) {
        this.invProjects = [] as Project[]
        this.$api
          .get(`/inventories`, {
            params: {
              search: query,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            apiResponse.data.forEach((project: Project) => {
              this.invProjects.push(project)
            })
          })
      }

      return this.invProjects
    },
    searchRequisitions(query: string): Project[] {
      if (query.length >= 3) {
        this.reqProjects = [] as Project[]
        this.$api
          .get(`/requisitions`, {
            params: {
              search: query,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            apiResponse.data.forEach((project: Project) => {
              this.reqProjects.push(project)
            })
          })
      }

      return this.reqProjects
    },
    transferToRequisition() {
      //if (this.transferTo !== null) {
      this.busy = true

      const loading = this.$loading({
        target: '#transferModal',
        text: 'Transfert en cours...',
      })

      let items = [] as number[]

      for (let index = 0; index < this.itemsChecked.length; index++) {
        if (this.itemsChecked[index]) {
          items.push(this.items[index].id ?? 0)
        }
      }

      let params = {
        requisition: this.transferTo,
        items,
        useStickerAsStockId: this.useStickerAsStockId,
        useStickerAsItemNumber: this.useStickerAsItemNumber,
        checkIfStockIdExist: this.checkIfStockIdExist,
      } //as TransferParams

      let url = `/inventory/${this.project.inventory?.id}/items/transfer/requisition`
      //if (!this.isInventoryTransfer) {
      // url = `${url}/requisition`
      // params = {
      //   ...params,
      //   useStickerAsStockId: this.useStickerAsStockId,
      //   checkIfStockIdExist: this.checkIfStockIdExist,
      // }
      //}

      this.$api
        .post(url, params)
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          // this.$notify({
          //   type: 'success',
          //   title: 'Succès',
          //   message: 'Opération réalisée avec succès !',
          // })

          // if (this.isInventoryTransfer) {
          //   this.items = apiResponse.data
          //   this.$emit('inventoryItemsTransfered')
          // }
          this.toggleCheckAll(false)
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            let errorMessage = apiResponse.message
            if (apiResponse.data) {
              errorMessage = `${errorMessage} : ${apiResponse.data}`
            }

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: errorMessage ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.showTransferModal = false
          this.transferTo = null
          //this.projects = []
          //this.resetModalCheckbox()
          this.busy = false
          loading.close()
        })
      //}
    },
    transferToInventory() {
      //if (this.transferTo !== null) {
      this.busy = true

      const loading = this.$loading({
        target: '#invTransferModal',
        text: 'Transfert en cours...',
      })

      let items = [] as number[]

      for (let index = 0; index < this.itemsChecked.length; index++) {
        if (this.itemsChecked[index]) {
          items.push(this.items[index].id ?? 0)
        }
      }

      let params = {
        inventory: this.transferTo,
        items,
      } //as TransferParams

      let url = `/inventory/${this.project.inventory?.id}/items/transfer`

      this.$api
        .post(url, params)
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.items = apiResponse.data
          this.$emit('refreshProject')
          this.toggleCheckAll(false)
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            let errorMessage = apiResponse.message
            if (apiResponse.data) {
              errorMessage = `${errorMessage} : ${apiResponse.data}`
            }

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: errorMessage ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.showInvTransferModal = false
          this.transferTo = null
          //this.projects = []
          this.busy = false
          loading.close()
        })
      //}
    },
    closeTransferModal() {
      this.showInvTransferModal = false
      this.showTransferModal = false
      this.transferTo = null
      //this.projects = []
    },

    renumber(choice: string | null) {
      let data = {
        orderBy: null as string | null,
        start: 1,
      }

      let popupTile = 'Renumérotation'

      switch (choice) {
        case 'place':
          data.orderBy = 'place'
          popupTile += ' par lieu puis emplacement'
          break

        case 'place-rubrique':
          data.orderBy = 'place-rubrique'
          popupTile += ' par lieu puis rubrique'
          break

        case 'rubrique':
          data.orderBy = 'rubrique'
          popupTile += ' par rubrique'
          break

        case 'date':
          data.orderBy = 'date'
          popupTile += ' par date de création'
          break

        case 'sticker':
          data.orderBy = 'sticker'
          popupTile += " par n° d'étiquette"
          break
      }

      this.$prompt('Numéro de départ', popupTile, {
        confirmButtonText: 'Renuméroter',
        cancelButtonText: 'Annuler',
        inputValue: '1',
        inputType: 'number',
      }).then((res) => {
        const value = (res as MessageBoxInputData).value

        const parsed = Number.parseInt(value)
        if (!Number.isNaN(parsed)) {
          data.start = parsed
        }

        this.$api.post(`/inventory/${this.project.inventory?.id}/items/renumber`, data).then((response) => {
          const apiResponse = response.data as ApiResponse

          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Inventaire renuméroté avec succès.',
          })

          this.items = apiResponse.data
          this.filterItemList()
        })
      })
    },
    // handleClose(done: CallableFunction) {
    //   this.saveTrigger = !this.saveTrigger
    //   done()
    // },
    resetChangeDetection() {
      // This event is used because the item change is not detected when a user opens the same inventory item twice
      this.resetChange = !this.resetChange
    },
    editInventoryItems() {
      let items = [] as number[]
      this.itemsToEdit = []

      for (let index = 0; index < this.itemsChecked.length; index++) {
        if (this.itemsChecked[index] === true) {
          items.push(this.items[index].id ?? 0)
        }
      }

      this.itemsToEdit = items

      if (items.length > 0) {
        this.showEditModal = true
      }
    },
    closeEditModal() {
      this.showEditModal = false
      this.indeterminate = false

      for (let i = 0; i < this.itemsChecked.length; i++) {
        this.itemsChecked[i] = false
      }

      this.itemsToEdit = []
      this.fetchInventoryItems(this.project.inventory?.id ?? null)
    },
    /*
    resetModalCheckbox() {
      this.useStickerAsStockId = true
      this.useStickerAsItemNumber = false
      this.checkIfStockIdExist = true
    },
    */
    setQuery(query: Parameter) {
      //console.log("query updated")
      this.query = query
    },
    filterItemList() {
      //console.log("filterItemList")
      let filtered = false
      //this.itemsChecked = 0
      this.toggleCheckAll(false)

      this.filteredItems = Object.assign([], this.items) // copy because sort change l'ordre de l'objet d'origine (de this.item)

      if (this.query?.search && this.query?.search !== '') {
        this.filteredItems = this.filteredItems.filter((item: InventoryItem) =>
          item.description?.toLowerCase().includes(this.query?.search?.toLowerCase() ?? '')
        )
        filtered = true
      }

      if (this.query?.itemNumber) {
        this.filteredItems = this.filteredItems.filter(
          (item: InventoryItem) => item.sticker == this.query?.itemNumber
        )
        filtered = true
      }

      // 2026-11-04 Claude : Combine les filtres du dossier par lieu, emplacement et rubrique avec les filtres existants.
      if (this.query?.place) {
        this.filteredItems = this.filteredItems.filter((item: InventoryItem) => item.place === this.query?.place)
      }
      if (this.query?.location) {
        this.filteredItems = this.filteredItems.filter(
          (item: InventoryItem) => item.location === this.query?.location
        )
      }
      if (this.query?.rubriques?.length) {
        this.filteredItems = this.filteredItems.filter((item: InventoryItem) =>
          this.query?.rubriques?.includes(item.rubriqueKey ?? '')
        )
      }

      //this.setFilteredItemIds()

      if (this.query?.sort) {
        this.sortItems()
        filtered = true
      }
    },
    sortItems() {
      switch (this.query?.sort) {
        case 'estimationLowAsc':
          this.filteredItems = this.filteredItems.sort(this.sortByValue1Asc)
          break
        case 'estimationLowDesc':
          this.filteredItems = this.filteredItems.sort(this.sortByValue1Desc)
          break
        case 'photos':
          this.filteredItems = this.filteredItems.sort(this.sortByPhotos)
          break
      }
    },
    sortByValue1Asc(item1: InventoryItem, item2: InventoryItem) {
      const value1 = parseInt(item1.value1 ?? '0')
      const value2 = parseInt(item2.value1 ?? '0')
      if (value1 > value2) {
        return 1
      }
      if (value1 < value2) {
        return -1
      }
      return 0
    },
    sortByValue1Desc(item1: InventoryItem, item2: InventoryItem) {
      const value1 = parseInt(item1.value1 ?? '0')
      const value2 = parseInt(item2.value1 ?? '0')
      if (value1 > value2) {
        return -1
      }
      if (value1 < value2) {
        return 1
      }
      return 0
    },
    estimationTotal() {
      const totals = [0, 0, 0]

      this.filteredItems.forEach((item: InventoryItem) => {
        totals[0] += parseInt(item.value1 ?? '0') || 0
        totals[1] += parseInt(item.value2 ?? '0') || 0
        totals[2] += parseInt(item.value3 ?? '0') || 0
      })

      return totals
        .map((total) =>
          new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
          }).format(total)
        )
        .join(' - ')
    },
    photosTotal() {
      let total = 0

      this.filteredItems.forEach((item: InventoryItem) => {
        total += item.inventoryItemFiles.filter((file) => file.type === 'image' && file.deletedAt == null).length
      })

      return total
    },
    sortByPhotos(item1: InventoryItem, item2: InventoryItem) {
      const value1 = item1.inventoryItemFiles.length
      const value2 = item2.inventoryItemFiles.length
      if (value1 > value2) {
        return 1
      }
      if (value1 < value2) {
        return -1
      }
      return 0
    },
  },
})
